export default {
  FETCH_NOTIFICATION: "FETCH_NOTIFICATION",
  FETCH_NOTIFICATION_SUCCEEDED: "FETCH_NOTIFICATION_SUCCEEDED",
  UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
  UPDATE_NOTIFICATION_SUCCEEDED: "UPDATE_NOTIFICATION_SUCCEEDED",
  RESET_NOTIFICATION_UPDATED_FLAG: "RESET_NOTIFICATION_UPDATED_FLAG"
};
